/** Money is integer paise everywhere. Quantities are integer milli-units (1 pc = 1000). */

const inr = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const inr0 = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

export function formatMoney(paise: number, opts: { symbol?: boolean; whole?: boolean } = {}): string {
  const { symbol = true, whole = false } = opts;
  const sign = paise < 0 ? '−' : '';
  const value = Math.abs(paise) / 100;
  return sign + (symbol ? '₹' : '') + (whole ? inr0.format(value) : inr.format(value));
}

/** "12.5" | "12" | "₹1,200.50" → paise. Returns NaN when unparseable. */
export function parseMoney(input: string): number {
  const cleaned = input.replace(/[₹,\s]/g, '');
  if (!/^-?\d*(\.\d{0,2})?$/.test(cleaned) || cleaned === '' || cleaned === '-') return NaN;
  return Math.round(parseFloat(cleaned) * 100);
}

export function formatQty(milli: number, unit: string): string {
  if (unit === 'pc' || unit === 'pack') {
    return Number.isInteger(milli / 1000) ? String(milli / 1000) : (milli / 1000).toFixed(3);
  }
  return (milli / 1000).toFixed(3).replace(/\.?0+$/, '') + ' ' + unit;
}

/** "1.25" → 1250 milli-units. */
export function parseQty(input: string): number {
  const n = parseFloat(input.replace(',', '.'));
  return Number.isFinite(n) ? Math.round(n * 1000) : NaN;
}
